import React, { useContext } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Headline } from "../../components/Headline/Headline";
import { Smartphone } from "../../components/Icons/Smartphone";
import { Timer } from "../../components/Icons/Timer";
import { Padlock } from "../../components/Icons/Padlock";
import { Section } from "../../components/Section/Section";
import { DownloadIcons } from "../../components/DownloadIcons/DownloadIcons";
import TopFAQ from "../../components/TopFAQ/TopFAQ";
import { Stage } from "../../components/Stage/Stage";
import { LogoSmall } from "../../components/Icons/LogoSmall";
import device from "../../assets/device.png";
import device2x from "../../assets/device@2x.png";
import bitmap from "../../assets/bitmap.jpg";
import bitmap2x from "../../assets/bitmap@2x.jpg";
import bitmap3x from "../../assets/bitmap@3x.jpg";
import { ContentBox } from "../../components/ContentBox/ContentBox";
import { AOS_ANIMATION, AOS_DELAY } from "../../config";
import { ParallaxImage } from "../../components/ParallaxImage/ParallaxImage";
import { InstallationCTAs } from "../../components/InstallationCTAs/InstallationCTAs";
import { FeaturesList } from "../../components/FeaturesList/FeaturesList";
import { Link } from "react-router-dom";
import { InstallationContext } from "../../contexts/InstallationContext";
import { HTMLParser } from "../../components/HTMLParser/HTMLParser";
import { FeaturesContext } from "../../contexts/FeaturesContext";
import { AttributesContext } from "../../contexts/AttributesContext";

export const Homepage: React.FC = () => {
  const installationContext = useContext(InstallationContext);
  const installation = installationContext.installationItems[0];
  const featuresContext = useContext(FeaturesContext);
  const features = featuresContext.featureItems[0];
  const attributesContext = useContext(AttributesContext);
  const attributes = attributesContext.attributesItems[0];

  return (
    <div className="homepage page">
      <Stage />

      {installation && (
        <Section name="intro">
          <Container>
            <Row>
              <Col md={6} className="center-horizontal hidden-below-md">
                <ParallaxImage
                  className="intro-image"
                  src={device}
                  srcSet={`${device} 1x, ${device2x} 2x`}
                  alt="Screenshot der Smartphone App"
                  data-aos={AOS_ANIMATION}
                />
              </Col>
              <Col xl={5} md={6} className="intro-content center-vertical">
                <div className="logo-small-headline">
                  <LogoSmall dataAos={AOS_ANIMATION} />
                  <Headline as="h1" dataAos={AOS_ANIMATION}>
                    <HTMLParser html={installation.headline_installation} />
                  </Headline>
                </div>
                <p className="lead" data-aos={AOS_ANIMATION}>
                  {installation.text_installation}
                </p>
                <DownloadIcons dataAos={AOS_ANIMATION} />
              </Col>
            </Row>
          </Container>
        </Section>
      )}
      {installation && (
        <Section background="lightblue">
          <Container>
            <Row>
              <Col>
                <Headline as="h1" forceLeft dataAos={AOS_ANIMATION}>
                  <HTMLParser html={installation.headline_install_buttons} />
                </Headline>
              </Col>
            </Row>
            <InstallationCTAs />
          </Container>
        </Section>
      )}

      {features && (
        <Section>
          <Container>
            <Row>
              <Col>
                <Headline as="h1" dataAos={AOS_ANIMATION}>
                  <HTMLParser html={features.headline_features} />
                </Headline>
              </Col>
            </Row>
            <Row md={2} xs={1}>
              <Col md={6} className="align-self-center">
                <FeaturesList />
              </Col>
              <Col md={{ span: 5, offset: 1 }}>
                <img
                  className="cover"
                  src={bitmap}
                  srcSet={`${bitmap} 1x, ${bitmap2x} 2x, ${bitmap3x} 3x`}
                  alt="Patient und Ärztin"
                  data-aos={AOS_ANIMATION}
                  data-aos-delay={AOS_DELAY}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="button-wrapper">
                  <Button
                    className="mt-xl"
                    as={Link}
                    to={`/article/7`}
                    data-aos={AOS_ANIMATION}
                  >
                    Mehr erfahren
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Section>
      )}

      {attributes && (
        <Section background="lightblue">
          <Container>
            <Row>
              <Col>
                <Headline as="h1" dataAos={AOS_ANIMATION}>
                  <HTMLParser html={attributes.headline_attributes} />
                </Headline>
              </Col>
            </Row>
            <Row xs={1} md={3}>
              <Col>
                <ContentBox
                  headline={attributes.headline_attribute1}
                  Icon={Timer}
                  dataAos={AOS_ANIMATION}
                >
                  <HTMLParser html={attributes.text_attribute1} />
                </ContentBox>
              </Col>
              <Col>
                <ContentBox
                  headline={attributes.headline_attribute2}
                  Icon={Padlock}
                  dataAos={AOS_ANIMATION}
                  dataAosDelay={1 * AOS_DELAY}
                >
                  <HTMLParser html={attributes.text_attribute2} />
                </ContentBox>
              </Col>
              <Col>
                <ContentBox
                  headline={attributes.headline_attribute3}
                  Icon={Smartphone}
                  dataAos={AOS_ANIMATION}
                  dataAosDelay={2 * AOS_DELAY}
                >
                  <HTMLParser html={attributes.text_attribute3} />
                </ContentBox>
              </Col>
            </Row>
          </Container>
        </Section>
      )}

      <Section>
        <Container>
          <Row>
            <Col>
              <Headline
                as="h1"
                normal="FAQs"
                bold="Häufig gestellte Fragen"
                forceLeft
                dataAos={AOS_ANIMATION}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TopFAQ dataAos={AOS_ANIMATION} />
              <div className="button-wrapper">
                <Button
                  className="mt-xl"
                  as={Link}
                  to={`/help`}
                  data-aos={AOS_ANIMATION}
                >
                  Hilfe &amp; Support
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </div>
  );
};
